import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import cn from 'classnames';
import { getTestIds } from '../../utils/TestIds';
import { useDevice } from '../Device';
import styles from './GridItem.module.scss';
export const GetGridItemTID = (parentTestId)=>getTestIds(parentTestId);
export function GridItem(_0) {
    let { className, span, justify, collapseOnMobile, testId } = _0, rest = _object_without_properties(_0, [
        "className",
        "span",
        "justify",
        "collapseOnMobile",
        "testId"
    ]);
    const { isMobileDevice } = useDevice();
    const { GridItemTID } = useMemo(()=>GetGridItemTID(testId), [
        testId
    ]);
    const effectiveSpan = collapseOnMobile && isMobileDevice ? 12 : span;
    return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({
        className: cn(styles.root, className),
        "data-testid": GridItemTID.Root()
    }, rest), {
        style: {
            '--cellWidth': effectiveSpan,
            justifySelf: justify
        }
    }));
}
